import React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

const CustomPrintModel = ({ contentId, children, sx, }) => {
    return (
        <Box
            id={contentId}
            sx={{
                ...sx,
                display: "none",
            }}
        >
            <div style={{
                paddingRight: "30px",
                paddingLeft: "30px",
                paddingTop: "10px"
            }}>
                {children}
            </div>
        </Box>
    );
};

CustomPrintModel.propTypes = {
    children: PropTypes.node.isRequired,
    sx: PropTypes.object,
    bgColor: PropTypes.string,  // Added bgColor prop for custom background
};

export default CustomPrintModel;
